import {
  api_react_v1_current_user_info_path,
  api_user_info_path,
  api_user_update_path,
} from '../../routes';
import request from './request';

export const CURRENT_USER_KEY = 'CURRENT_USER_KEY';
export const NAV_CURRENT_USER_KEY = 'NAV_CURRENT_USER_KEY';

export enum CommentableType {
  ForumPost = 'ForumPost',
  Comment = 'Community::Comment',
}

export type User = {
  administrator: {
    is_active: boolean;
  };
  access_level: number;
  authenticated_by_jwt: boolean;
  can_initiate_mobile_subscription: boolean;
  can_actually_comment: boolean;
  can_view_group_sub_option: boolean;
  company_name: string | null;
  email: string;
  guid: string;
  has_set_password: boolean;
  id: number;
  identity_id: number;
  login_link_only: boolean;
  is_free_edition_user: boolean;
  is_group_subscriber: boolean;
  is_new_user: boolean;
  is_subscriber: boolean;
  is_team_admin: boolean;
  is_pro_subscriber: boolean;
  name: string | null;
  one_line_bio: string | null;
  permitted_to_comment: boolean;
  picture_url: string | null;
  profile_enabled: boolean;
  requires_name_to_comment: boolean;
  referral_url: string;
  staff: boolean;
  can_view_forum_posts: boolean;
  subscription: {
    source: string;
    plan_type: string;
    is_past_due: boolean;
    is_pro: boolean;
    is_active: boolean;
  };
  title_at_company: string | null;
  username: string;
  affiliate_code?: string;
  settings_access_obj: {
    group_sub_access: boolean;
    privacy_access: boolean;
    referral_access: boolean;
  };
};

export interface NavCurrentUser {
  isLoggedIn: boolean;
  isProSubscriber: boolean;
  isSubscriber: boolean;

  willSubscriptionChange: boolean;
  avatarUrl?: string;
  canViewGiftOption: boolean;
  profileCompletionPercentage: number;
  profileCompletionStatuses: { text: string; isComplete: boolean; href: string }[];
  username?: string;
  referralUrl?: string;
  planType?: string;
  initialSubscribeDateStr?: string;
}

export type NavProps = {
  isFullNav: boolean;
  isWebview: boolean;
  colorScheme: string;
  currentUser: NavCurrentUser;
  shouldOpenReferralModal: boolean;
  newForumPostsCount: number;
};

export type NavCurrentUserResponse = {
  navProps: NavProps;
};

// TODO: Adapt for other commentable types
export async function getCurrentUser(): Promise<User> {
  const resp = await request('get', api_user_info_path());
  return resp?.user;
}

export async function getNavCurrentUser(): Promise<NavCurrentUserResponse> {
  const resp = await request('get', api_react_v1_current_user_info_path());
  return resp;
}

export interface SanitizedUserParams {
  profile_enabled?: boolean;
  title_at_company?: boolean;
  company_name?: boolean;
}

export async function updateCurrentUser(values: SanitizedUserParams): Promise<{ user: User }> {
  const resp = await request('patch', api_user_update_path(values));
  return resp;
}
